import React from 'react';

export function Brazil(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="513" height="342" fill="#009C3B"/>
      <polygon points="256.5,30 483,171 256.5,312 30,171" fill="#FEDF00"/>
      <circle cx="256.5" cy="171" r="71" fill="#002776"/>
      <path d="M185,155 Q256,130 328,155" stroke="white" strokeWidth="8" fill="none"/>
    </svg>
  );
}
